import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { Toaster } from 'react-hot-toast';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Router>
    <App />
    <Toaster position="top-right" />
  </Router>
);
